import styled, { css, keyframes } from "styled-components";

// Medidas de docs/contexto-entrega/painel-entrega-documentacao_v2.md §7.
// Cores dos tokens do projeto e da identidade visual por empresa.

const pulsar = keyframes`
  0%, 100% { opacity: 0.4; }
  50%      { opacity: 1; }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.neutralBorder};

  ${(props) =>
    props.atencao &&
    css`
      border-color: ${props.theme.colors.warning};
      background-color: ${props.theme.colors.info};
    `}
`;

export const FaixaConflito = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 12px 16px;
  border-radius: 16px 16px 0 0;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warning};
  background-color: ${({ theme }) => theme.colors.info};
  border: 1px solid ${({ theme }) => theme.colors.warning};
  border-bottom: none;

  svg {
    flex-shrink: 0;
  }

  /* Colado ao card que vem logo abaixo. */
  + div {
    margin-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const Linha = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
`;

export const IconBadge = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
`;

export const LinhaTitulo = styled.span`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.43;
  color: ${({ theme }) => theme.colors.ink};

  &::after {
    content: "";
    flex: 1;
    min-width: 24px;
    border-bottom: 1px dotted ${({ theme }) => theme.colors.neutralBorder};
  }
`;

export const LinhaDetalhe = styled.span`
  flex-shrink: 0;
  font-size: 1.4rem;
  font-weight: 800;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.black};
  white-space: nowrap;
`;

export const NotaCentro = styled.p`
  margin: 0;
  font-size: 1.2rem;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.neutralText};
`;

export const Aviso = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 1.3rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.ink};

  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.warning};
  }
`;

export const BotaoContornado = styled.button`
  align-self: flex-start;
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.ink};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.neutralBorder};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const LinkAcao = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    color: ${({ theme }) => theme.colors.primaryDark};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 8px;
  }
`;

export const Rodape = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.neutralBorder};
`;

export const RodapeTexto = styled.span`
  font-size: 1.2rem;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.neutralText};
`;

export const LinkAlterar = styled.button`
  /* 39x16 no protótipo, abaixo do mínimo de toque. A área cresce sem deslocar o texto. */
  position: relative;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.33;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 44px;
    width: 100%;
    height: 44px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primaryDark};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const BlocoCarregando = styled.div`
  width: 160px;
  height: 12px;
  border-radius: 9999px;
  background-color: ${({ theme }) => theme.colors.neutralBg};
  animation: ${pulsar} 1.2s ease-in-out infinite;
`;

export const ConsultaBloco = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConsultaRotulo = styled.label`
  margin-bottom: 6px;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
`;

export const ConsultaLinha = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
`;

export const ConsultaInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 44px;
  padding: 10px 16px;
  border-radius: 9999px;
  font-size: 1.5rem;
  outline: none;
  color: ${({ theme }) => theme.colors.ink};
  background-color: ${({ theme }) => theme.colors.neutralBg};
  transition: border-color 150ms cubic-bezier(0.4, 0, 0.2, 1);

  border: 1px solid
    ${(props) => (props.invalido ? props.theme.colors.error : props.theme.colors.neutralBorder)};

  &:focus {
    border-color: ${(props) =>
    props.invalido ? props.theme.colors.error : props.theme.colors.primary};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutralText};
  }
`;

export const ConsultaBotao = styled.button`
  flex-shrink: 0;
  height: 44px;
  padding: 10px 20px;
  border-radius: 9999px;
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.ink};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.neutralBorder};

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const ConsultaApoio = styled.span`
  margin-top: 8px;
  font-size: 1.2rem;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.neutralText};
`;

export const MensagemErro = styled.span`
  margin-top: 8px;
  font-size: 1.2rem;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.error};
`;
